<template>
	<main id="archive-posts" class="archive page main" :key="'archive-' + currentPostType">
		<SingleHeading />

		<transition :style="{ '--totalStagger': 4 }" name="slide-in" appear>
			<PageWrapper :style="'--indexStagger: 4'">
				<ModuleBuilder />
				<PostsGrid :posts="postsToShow.slice(0, toShowCount)" class="container container--large" />
				<div
					v-if="isMoreToShow && postsToShow.length"
					class="margin-bottom-xl margin-top-xl load-more-button text-center"
				>
					<Button
						aria-label="Load more elements"
						has-icon
						icon-type="down"
						uppercase
						v-observe-visibility="visibilityChanged"
						type="darkLight"
						@click.native="loadMore()"
					>
						LOAD MORE
					</Button>
				</div>
				<div
					v-if="postsLoaded && !isMoreToShow && postsToShow.length == 0"
					class="container no-resultats margin-bottom-lg text-center"
				>
					<div class="inner-error">{{ _('try different filters') }}</div>
				</div>
			</PageWrapper>
		</transition>
	</main>
</template>

<script>
import PostsGrid from '@/components/parts/PostsGrid'
import Button from '@/components/elements/Button'
import Breadcrumbs from '@/components/parts/Breadcrumbs'
import SingleHeading from '@/components/parts/SingleHeading'
import ModuleBuilder from '@/components/ModuleBuilder'
import PageWrapper from '@/components/elements/PageWrapper'

import { mapActions, mapGetters } from 'vuex'

export default {
	name: 'archive-page',
	components: {
		PostsGrid,
		Button,
		Breadcrumbs,
		SingleHeading,
		ModuleBuilder,
		PageWrapper,
	},
	data() {
		return {
			selectedCategory: '',
			postsLoaded: false,
			filters: {
				clinic_category: [],
				category: {},
				diet_level: [],
				meal_type_selected: [],
				type_of_ingredients_selected: [],
				search: '',
			},
			posts: [],
			toShowDefault: 6,
			toShowCount: 6,
			showBy: 6,
			countAll: 0,
		}
	},
	watch: {
		postsLoaded(val) {
			if (val) {
				const urlFilters = Object.assign({}, this.$route.query)
				let query = {}
				if (Object.keys(urlFilters).length) {
					if (urlFilters.hasOwnProperty('category_ambasador')) {
						query = { ...query, ...urlFilters }
					}
					if (urlFilters.hasOwnProperty('category')) {
						query = { ...query, ...urlFilters }
					}
					//consoleconsole.log(query)
				}
				//trigger first router/filters action
			}
		},
	},
	mounted() {
		this.loadPosts()
		//console.log(this.$route)
	},
	methods: {
		filtersUpdate(value) {
			switch (value.action) {
				case 'search':
				case 'clinic_category':
				case 'category':
				case 'diet_level':
				case 'type_of_ingredients_selected':
				case 'meal_type_selected':
					this.filters[value.action] = value.value
					break
			}
		},
		...mapActions(['getPost']),
		loadPosts() {
			const VM = this
			VM.getPost(VM.apiOptLoad).then((res) => {
				const { posts } = res.data
				if (posts && posts.length) {
					VM.countAll = posts.length
					VM.posts = posts
					VM.postsLoaded = true
				}
			})
		},
		loadMore() {
			this.toShowCount = this.toShowCount + this.showBy
		},
		visibilityChanged(isVisible) {
			if (isVisible) {
				this.loadMore()
			}
		},
	},
	computed: {
		...mapGetters(['storedTaxonomy', 'currentPostType', 'currentPage', 'storedTaxonomyBySlug']),
		apiOptLoad() {
			return {
				type: this.currentPostType || 'post',
				order_by: 'menu_order',
				order: 'ASC',
				limit: 50000,
			}
		},

		isMoreToShow() {
			return this.toShowCount < this.postsToShow.length
		},
		postsToShow() {
			const VM = this
			if (!this.posts) return false

			const toShow = VM.posts
				.filter((p, i) => {
					//search
					const searchQuery = VM.filters.search
					let showMe = true
					if (searchQuery) showMe = p.title.toUpperCase().indexOf(searchQuery.toUpperCase()) > -1
					return showMe
				})
				.filter((p, i) => {
					// post category
					if (VM.filters.category && VM.filters.category.slug) {
						const category = VM.storedTaxonomyBySlug('category', VM.filters.category.slug)
						const postCategory = p.acf && p.acf.category ? p.acf.category : false
						return category && postCategory && ~postCategory.indexOf(category.id)
					}
					return true
				})
				.filter((p, i) => {
					// post Clinic category
					if (VM.filters.clinic_category && VM.filters.clinic_category.slug) {
						const category = VM.storedTaxonomyBySlug('clinic_category', VM.filters.clinic_category.slug)
						const postCategory = p.acf && p.acf.clinic_category ? p.acf.clinic_category : false
						return category && postCategory && postCategory === category.id
					}
					return true
				})
				.filter((p, i) => {
					// post diet_level
					if (VM.filters.diet_level && VM.filters.diet_level.slug) {
						const category = VM.filters.diet_level
						const postCategory = p.acf && p.acf.recipe_level ? p.acf.recipe_level : false
						return category && postCategory && Number(postCategory) <= Number(category.value)
					}
					return true
				})
				.filter((p, i) => {
					// post meal_type_selected
					if (VM.filters.meal_type_selected && VM.filters.meal_type_selected.length) {
						const category = VM.filters.meal_type_selected
						return category.some((r) => p.acf.meal_type.indexOf(r.id) >= 0)
					}
					return true
				})
				.filter((p, i) => {
					// post type_of_ingredients
					if (VM.filters.type_of_ingredients_selected && VM.filters.type_of_ingredients_selected.length) {
						const category = VM.filters.type_of_ingredients_selected
						return category.some((r) => p.acf.type_of_ingredients.indexOf(r.id) >= 0)
					}
					return true
				})

			return toShow && toShow.length ? toShow : []
		},
	},
}
</script>

<style lang="scss">
@import '@/assets/vars.scss';
@import '@/assets/mixins.scss';

.load-more-button .fill-button-text {
	font-size: 18px;
}
.archive {
	.headg-filters {
	}
	.no-resultats {
		font-weight: 900;
		margin-top: 30px;
		padding: 30px;
		color: var(--dark);
		border: 5px solid var(--dark);
		@include fluid-type($smallResText, $wideResText, 18px, 25px);
	}
	.professions-filters {
		background-color: transparent;
		&:after,
		&:before {
			content: none;
		}
	}
	.archive-filters-single {
		max-width: 350px;
		&.is-multiple {
			.vs__selected {
				background: var(--light);
				border: none;
				padding: 3px 5px;
				@include fluid-type($smallResText, $wideResText, 12px, 14px);
				color: var(--dark);
				border-radius: 40px;
			}
			.vs__selected-options {
				svg path {
					fill: var(--dark);
				}
			}
		}
		.vs__selected-options {
			flex-wrap: nowrap;
			align-items: center;
		}
		.vs__actions {
			padding-right: 25px;
		}
		.vs__selected {
			color: var(--dark);
			padding-left: 25px;
			margin: 0;
		}
		.vs__clear {
			background: $red;
			width: 20px;
			height: 20px;
			border-radius: 15px;
			position: relative;
			svg {
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
			}
			path {
				fill: var(--light);
			}
		}
		.vs__dropdown-toggle {
			border: 2px solid var(--dark);
			background-color: var(--light);
			border-radius: 50px;
			padding-bottom: 0;
			color: var(--dark);
			font-weight: 600;
			cursor: pointer;
			white-space: nowrap;
			input {
				font-weight: 600;
				padding: 10px 24px;
				padding-right: 2px;
				margin-top: 0;
				color: var(--dark);
			}
		}
		.vs__open-indicator {
			fill: var(--dark);
		}
	}
}
</style>
